import gql from 'graphql-tag';
import { eventAttributes, eventEditableAttributes, eventListingAttributes } from './types/event';
import { eventSeriesAttributes } from './types/event-series';

const editEventSeriesAttributes = `
  ${eventSeriesAttributes}
  description
  recurringType
  monthlyRecurringType
  separationCount
  weekOfMonth
  dayOfWeek
  dayOfMonth
`;

export const convertEventToSeriesQuery = gql`
  query ConvertEventToSeriesQuery($id: ID!) {
    event(id: $id) {
      id
      ${eventEditableAttributes}
      series {
        id
      }
    }
  }
`;

export const createEventSeriesMutation = gql`
  mutation CreateEventSeriesMutation($data: NewEventSeriesInput!, $cityId: ID!, $convertEventIds: [ID]) {
    createEventSeries(data: $data, cityId: $cityId, convertEventIds: $convertEventIds) {
      id
      name
    }
  }
`;

export const updateEventSeriesMutation = gql`
  mutation CreateEventSeriesMutation($id: ID!, $data: EventSeriesInput!) {
    updateEventSeries(id: $id, data: $data) {
      ${editEventSeriesAttributes}
    }
  }
`;

export const eventSeriesConvertibleEventsQuery = gql`
  query EventSeriesConvertibleEventsQuery($hostType: EventOwnerType!, $groupId: ID) {
    eventSeriesConvertibleEvents(hostType: $hostType, groupId: $groupId) {
      id
      name
      startAt
      endAt
    }
  }
`;

export const eventSeriesQuery = gql`
  query EventSeriesQuery($id: ID!) {
    eventSeries(id: $id) {
      ${eventSeriesAttributes}
      description
      permissions {
        editable
      }
      upcomingEvents {
        ${eventListingAttributes}
      }
      pastEventsCount
      user {
        websiteUrl
        instagramUsername
        pastHostedEventsCount
      }
      group {
        websiteUrl
        instagramUsername
        pastEventsCount
        membersCount
      }
    }
  }
`;

export const eventSeriesPastQuery = gql`
  query EventSeriesPastQuery($id: ID!) {
    eventSeries(id: $id) {
      ${eventSeriesAttributes}
      permissions {
        editable
      }
      pastEvents {
        ${eventListingAttributes}
      }
      upcomingEvents {
        id
      }
    }
  }
`;

export const editEventSeriesQuery = gql`
  query EditEventSeriesQuery($id: ID!) {
    eventSeries(id: $id) {
      ${editEventSeriesAttributes}
      user {
        id
        displayName
        username
      }
      group {
        id
        name
        slug
      }
      upcomingEvents {
        id
        ${eventAttributes}
      }
      permissions {
        editable
      }
    }
  }
`;

export const scheduleEventSeriesQuery = gql`
  query ScheduleEventSeriesQuery($id: ID!) {
    eventSeries(id: $id) {
      ${editEventSeriesAttributes}
      pastEvents {
        id
        name
        startAt
        endAt
        timezone
      }
      upcomingEvents {
        id
        ${eventEditableAttributes}
      }
      scheduleDates(count: 12)
      permissions {
        editable
      }
    }
  }
`;

export const eventSeriesIndexQuery = gql`
  query MyEventSeriesQuery {
    me {
      id
      eventSeries {
        ${eventSeriesAttributes}
        recurringType
        monthlyRecurringType
        separationCount
        weekOfMonth
        dayOfWeek
        dayOfMonth
        upcomingEventsCount
      }
      groups {
        id
        name
        slug
        eventSeries {
          ${eventSeriesAttributes}
          recurringType
          monthlyRecurringType
          separationCount
          weekOfMonth
          dayOfWeek
          dayOfMonth
          upcomingEventsCount
        }
      }
    }
  }
`;
